var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      attrs: { drawer: _vm.drawer, withHeader: false, size: 1240 },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "view",
        },
        [
          _c(
            "div",
            { staticClass: "tag" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.active,
                    callback: function ($$v) {
                      _vm.active = $$v
                    },
                    expression: "active",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "基本信息", name: "0" },
                  }),
                ],
                1
              ),
              _c("i", {
                staticClass: "el-icon-close closeIcon",
                on: { click: _vm.close },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "panel panelActive1" },
            [
              _c(
                "el-form",
                {
                  ref: "billInfo",
                  attrs: { model: _vm.form, rules: _vm.rules },
                },
                [
                  _c(
                    "div",
                    { staticClass: "panel2" },
                    [
                      !_vm.billType
                        ? _c(
                            "div",
                            { staticClass: "panel-title" },
                            [
                              _c("svg-icon", {
                                style: { "font-size": 20 },
                                attrs: {
                                  iconClass: "panelTitle-icon",
                                  className: "icon",
                                },
                              }),
                              _vm._v(" 基本信息 "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("主提单号"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "mblNo" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "220px" },
                                      attrs: { size: "small" },
                                      on: {
                                        blur: _vm.changeMblNo,
                                        input: function ($event) {
                                          return _vm.onInput("blNo")
                                        },
                                      },
                                      model: {
                                        value: _vm.form.mblNo,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "mblNo", $$v)
                                        },
                                        expression: "form.mblNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("分单号"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "blNo" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "220px" },
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.form.blNo,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "blNo", $$v)
                                        },
                                        expression: "form.blNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("目的国家"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "countryCode" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          filterable: "",
                                          size: "small",
                                          placeholder: "请选择目的国家",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.form.destinationHarborName = ""
                                          },
                                        },
                                        model: {
                                          value: _vm.form.countryCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "countryCode",
                                              $$v
                                            )
                                          },
                                          expression: "form.countryCode",
                                        },
                                      },
                                      _vm._l(
                                        _vm.addressDropCodeOption,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("ETD - ETA"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "date" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "220px" },
                                      attrs: {
                                        type: "daterange",
                                        "unlink-panels": "",
                                        size: "small",
                                        "picker-options": _vm.pickerOptions,
                                        "value-format": "yyyy-MM-dd",
                                        "range-separator": "-",
                                        "start-placeholder": "请选择日期",
                                        "end-placeholder": "请选择日期",
                                      },
                                      model: {
                                        value: _vm.form.date,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "date", $$v)
                                        },
                                        expression: "form.date",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.billType ? "始发机场" : "始发港"
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "originHarborName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          placeholder: "请选择始发港",
                                        },
                                        model: {
                                          value: _vm.form.originHarborName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "originHarborName",
                                              $$v
                                            )
                                          },
                                          expression: "form.originHarborName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.orginPortOptions,
                                        function (item, $index) {
                                          return _c("el-option", {
                                            key: $index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.billType ? "目的机场" : "目的港"
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "destinationHarborName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          filterable: "",
                                          size: "small",
                                          placeholder: "请选择目的港",
                                        },
                                        model: {
                                          value: _vm.form.destinationHarborName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "destinationHarborName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.destinationHarborName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.destinPortOptions,
                                        function (item, $index) {
                                          return _c("el-option", {
                                            key: $index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.billType
                        ? _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("提单件数(件)"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "qty" } },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入提单件数",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onInput("qty")
                                            },
                                          },
                                          model: {
                                            value: _vm.form.qty,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "qty", $$v)
                                            },
                                            expression: "form.qty",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("方数(CBM)"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "weightCbm" } },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入方数",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onInput("weightCbm")
                                            },
                                          },
                                          model: {
                                            value: _vm.form.weightCbm,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "weightCbm",
                                                $$v
                                              )
                                            },
                                            expression: "form.weightCbm",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("重量(KG)"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "weightKgs" } },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            size: "small",
                                            placeholder: "请输入重量",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onInput("weightKgs")
                                            },
                                          },
                                          model: {
                                            value: _vm.form.weightKgs,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "weightKgs",
                                                $$v
                                              )
                                            },
                                            expression: "form.weightKgs",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("收货人"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "consigneeName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "414px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.consigneeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "consigneeName",
                                              $$v
                                            )
                                          },
                                          expression: "form.consigneeName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.consigneeOptions,
                                        function (item) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: item.label,
                                              attrs: {
                                                label: item.label,
                                                value: item.label,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.address)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.cityAddress)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.provinceEnName)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.countryName)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.postcode
                                                          ? item?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("发货人"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "shipperName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "414px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.shipperName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "shipperName",
                                              $$v
                                            )
                                          },
                                          expression: "form.shipperName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.shipperOptions,
                                        function (item) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: item.label,
                                              attrs: {
                                                label: item.label,
                                                value: item.label,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.address)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.cityAddress)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.provinceEnName)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.countryName)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.postcode
                                                          ? item?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("通知方"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "notifyPartyName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "414px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.notifyPartyName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "notifyPartyName",
                                              $$v
                                            )
                                          },
                                          expression: "form.notifyPartyName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.notifyPartyOptions,
                                        function (item) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: item.label,
                                              attrs: {
                                                label: item.label,
                                                value: item.label,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.address)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.cityAddress)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.provinceEnName)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.countryName)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.postcode
                                                          ? item?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("制造商"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "manufacturerName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "414px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.manufacturerName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "manufacturerName",
                                              $$v
                                            )
                                          },
                                          expression: "form.manufacturerName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.manufacturerOptions,
                                        function (item) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: item.label,
                                              attrs: {
                                                label: item.label,
                                                value: item.label,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.address)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.cityAddress)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.provinceEnName)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.countryName)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.postcode
                                                          ? item?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("进口商"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "importerName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "414px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.importerName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "importerName",
                                              $$v
                                            )
                                          },
                                          expression: "form.importerName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.importerList,
                                        function (item, index) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.name,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.address)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.cityAddress)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.provinceEnName)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.countryName)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.postcode
                                                          ? item?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("最终收货人"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "ultimateConsigneeName" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "414px" },
                                        attrs: {
                                          size: "small",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.form.ultimateConsigneeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "ultimateConsigneeName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.ultimateConsigneeName",
                                        },
                                      },
                                      _vm._l(
                                        _vm.ultimateConsigneeOptions,
                                        function (item) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: item.label,
                                              attrs: {
                                                label: item.label,
                                                value: item.label,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.address)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.cityAddress)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.provinceEnName)
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatStatusAddress"
                                                        )(item?.countryName)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.postcode
                                                          ? item?.postcode
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("清关方式"),
                                ]),
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { size: "small" },
                                    model: {
                                      value: _vm.form.clearenceType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "clearenceType", $$v)
                                      },
                                      expression: "form.clearenceType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-button",
                                      { attrs: { label: 0 } },
                                      [_vm._v("自清")]
                                    ),
                                    _c(
                                      "el-radio-button",
                                      { attrs: { label: 1 } },
                                      [_vm._v("平台清")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm.form.clearenceType === 1
                            ? [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "field" },
                                    [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v("接收DO邮箱"),
                                      ]),
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "receivedDoEmail" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "220px" },
                                            attrs: {
                                              placeholder:
                                                "接收DO邮箱（可多条输入）以,隔开",
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.form.receivedDoEmail,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "receivedDoEmail",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.receivedDoEmail",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "field" },
                                    [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v("接收DO公司名称"),
                                      ]),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { prop: "receivedDoCompany" },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "220px" },
                                            attrs: { size: "small" },
                                            model: {
                                              value: _vm.form.receivedDoCompany,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "receivedDoCompany",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.receivedDoCompany",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("原产国"),
                                ]),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { prop: "originCountry", label: "" },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          filterable: "",
                                          size: "small",
                                          placeholder: "请选择原产国",
                                        },
                                        model: {
                                          value: _vm.form.originCountry,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "originCountry",
                                              $$v
                                            )
                                          },
                                          expression: "form.originCountry",
                                        },
                                      },
                                      _vm._l(
                                        _vm.addressDropCodeOption,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("是否申报ISF"),
                                ]),
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { size: "small" },
                                    model: {
                                      value: _vm.form.isDeclareISF,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "isDeclareISF", $$v)
                                      },
                                      expression: "form.isDeclareISF",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-button",
                                      { attrs: { label: true } },
                                      [_vm._v("是")]
                                    ),
                                    _c(
                                      "el-radio-button",
                                      { attrs: { label: false } },
                                      [_vm._v("否")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("提货方式"),
                                ]),
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      input: function ($event) {
                                        _vm.form.deliveryType = 1
                                        _vm.form.code = ""
                                      },
                                    },
                                    model: {
                                      value: _vm.form.pickUpType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "pickUpType", $$v)
                                      },
                                      expression: "form.pickUpType",
                                    },
                                  },
                                  _vm._l(_vm.tabItems2, function (item) {
                                    return _c(
                                      "el-radio-button",
                                      {
                                        key: item.id,
                                        attrs: { label: item.id },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm.form.pickUpType === 1
                            ? [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "field" },
                                    [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v("直送类型"),
                                      ]),
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: {
                                            input: function ($event) {
                                              _vm.form.code = ""
                                            },
                                          },
                                          model: {
                                            value: _vm.form.deliveryType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "deliveryType",
                                                $$v
                                              )
                                            },
                                            expression: "form.deliveryType",
                                          },
                                        },
                                        _vm._l(_vm.tabItems3, function (item) {
                                          return _c(
                                            "el-radio-button",
                                            {
                                              key: item.id,
                                              attrs: { label: item.id },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "field" },
                                    [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.form.deliveryType === 0
                                                ? "快递商"
                                                : "仓库"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _vm.form.deliveryType !== 0
                                        ? _c(
                                            "el-form-item",
                                            { attrs: { prop: "code" } },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    clearable: "",
                                                    size: "small",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value: _vm.form.code,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "code",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.code",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.warehouseList,
                                                  function (item) {
                                                    return _c(
                                                      "el-option",
                                                      {
                                                        key: item.label,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.label,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              float: "left",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.label)
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              float: "right",
                                                              color: "#8492a6",
                                                              "font-size":
                                                                "13px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatStatusAddress"
                                                                  )(
                                                                    item?.addressLine1
                                                                  )
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatStatusAddress"
                                                                  )(
                                                                    item?.addressLine2
                                                                  )
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatStatusAddress"
                                                                  )(item?.city)
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatStatusAddress"
                                                                  )(item?.state)
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatStatusAddress"
                                                                  )(
                                                                    item?.countryCode
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item?.postalCode
                                                                    ? item?.postalCode
                                                                    : ""
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "expressSupplier",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "supplyList",
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.config
                                                    .expressSupplierOptions,
                                                  function (item, $index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: item.value,
                                                        staticClass: "item",
                                                        class: {
                                                          active:
                                                            _vm.kdSupplyIndex ===
                                                            $index,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.kdSupplyIndex =
                                                              $index
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "logoUrl",
                                                          attrs: {
                                                            src: require(`@/assets/images/serverSupply/${item.value.toLowerCase()}.png`),
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm.form.pickUpType === 2 && _vm.form.clearenceType === 1
                        ? _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("清关模式"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "clearanceMode" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "220px" },
                                            attrs: {
                                              filterable: "",
                                              clearable: "",
                                              size: "small",
                                              disabled: _vm.form.status,
                                              placeholder: "请选择清关模式",
                                            },
                                            model: {
                                              value: _vm.form.clearanceMode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "clearanceMode",
                                                  $$v
                                                )
                                              },
                                              expression: "form.clearanceMode",
                                            },
                                          },
                                          _vm._l(
                                            _vm.config.clearanceModesOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("卸货港"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "dischargeHarbor" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          filterable: "",
                                          placeholder: "请选择",
                                          size: "small",
                                        },
                                        model: {
                                          value: _vm.form.dischargeHarbor,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "dischargeHarbor",
                                              $$v
                                            )
                                          },
                                          expression: "form.dischargeHarbor",
                                        },
                                      },
                                      _vm._l(
                                        _vm.destinPortOptions,
                                        function (item, $index) {
                                          return _c("el-option", {
                                            key: $index,
                                            attrs: {
                                              label: item.label,
                                              value: item.label,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("卸货港日期"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "dischargeHarborDate" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "220px" },
                                      attrs: {
                                        type: "datetime",
                                        size: "small",
                                        placeholder: "请选择到卸货港日期",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                      },
                                      model: {
                                        value: _vm.form.dischargeHarborDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "dischargeHarborDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.dischargeHarborDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.rowData.status > 0
                        ? [
                            _c(
                              "el-row",
                              [
                                _vm.form.clearenceType
                                  ? _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("清关行"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "supplierClearenceId",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    size: "small",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form
                                                        .supplierClearenceId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "supplierClearenceId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.supplierClearenceId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.clearenceOptions,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.form.pickUpType
                                  ? _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("提货车行"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "supplierId" } },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    size: "small",
                                                  },
                                                  model: {
                                                    value: _vm.form.supplierId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "supplierId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.supplierId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.pickUpOptions,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.form.pickUpType === 2
                                  ? _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("拆柜供应商"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "supplierUnstuffingId",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    size: "small",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form
                                                        .supplierUnstuffingId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "supplierUnstuffingId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.supplierUnstuffingId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.unstuffingOptions,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("客户名称"),
                                ]),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "companyId" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          filterable: "",
                                          size: "small",
                                          placeholder: "请选择客户",
                                        },
                                        model: {
                                          value: _vm.form.companyId,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "companyId", $$v)
                                          },
                                          expression: "form.companyId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.companyDrapdown,
                                        function (item, $index) {
                                          return _c("el-option", {
                                            key: $index,
                                            attrs: {
                                              label: item.label,
                                              value: item.id,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm.rowData.status > 0
                    ? _c(
                        "div",
                        { staticClass: "panel2" },
                        [
                          _c("div", { staticClass: "panel-title" }, [
                            _c("div", { staticClass: "panel-titleInfo" }, [
                              _c(
                                "div",
                                [
                                  _c("svg-icon", {
                                    style: { "font-size": 20 },
                                    attrs: {
                                      iconClass: "panelTitle-icon",
                                      className: "icon",
                                    },
                                  }),
                                  _vm._v(" 跟进人信息 "),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("操作"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "operator" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "220px" },
                                            attrs: {
                                              multiple: "",
                                              filterable: "",
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: _vm.form.operator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "operator",
                                                  $$v
                                                )
                                              },
                                              expression: "form.operator",
                                            },
                                          },
                                          _vm._l(
                                            _vm.operatorOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.nameCH,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("客服"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "customer" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "220px" },
                                            attrs: {
                                              multiple: "",
                                              filterable: "",
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: _vm.form.customer,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "customer",
                                                  $$v
                                                )
                                              },
                                              expression: "form.customer",
                                            },
                                          },
                                          _vm._l(
                                            _vm.customerOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.nameCH,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 8 } }, [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v("财务"),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "financer" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "220px" },
                                            attrs: {
                                              multiple: "",
                                              filterable: "",
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: _vm.form.financer,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "financer",
                                                  $$v
                                                )
                                              },
                                              expression: "form.financer",
                                            },
                                          },
                                          _vm._l(
                                            _vm.financerOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.nameCH,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              !_vm.billType
                ? _vm._l(_vm.form.containers, function (item, $index) {
                    return _c(
                      "div",
                      { key: $index, staticClass: "panel2" },
                      [
                        _c("div", { staticClass: "panel-title" }, [
                          _c("div", { staticClass: "panel-titleInfo" }, [
                            _c(
                              "div",
                              [
                                _c("svg-icon", {
                                  style: { "font-size": 20 },
                                  attrs: {
                                    iconClass: "panelTitle-icon",
                                    className: "icon",
                                  },
                                }),
                                _vm._v(" 柜子信息 "),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c(
                          "el-form",
                          {
                            ref: `containerInfo${$index}`,
                            refInFor: true,
                            attrs: {
                              model: item,
                              rules: _vm.rules2,
                              "label-position": "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("柜号"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "containerNumber",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  placeholder:
                                                    "仅限输入数字和英文字符",
                                                  size: "small",
                                                  maxlength: 11,
                                                  oninput:
                                                    "value=value.replace(/[^0-9a-zA-Z]/g, '')",
                                                },
                                                model: {
                                                  value: item.containerNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "containerNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.containerNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("柜型"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: "containertypeName",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    size: "small",
                                                    placeholder: "请选择柜型",
                                                  },
                                                  model: {
                                                    value:
                                                      item.containertypeName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "containertypeName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.containertypeName",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.config
                                                    .containertypeOptions,
                                                  function (op, opi) {
                                                    return _c("el-option", {
                                                      key: opi,
                                                      attrs: {
                                                        label: op.label,
                                                        value: op.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("船名"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "vesselName" } },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "220px",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    size: "small",
                                                    "allow-create": "",
                                                    placeholder: "请选择船名",
                                                    "default-first-option": "",
                                                  },
                                                  model: {
                                                    value: item.vesselName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "vesselName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.vesselName",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.vesselNameOptions,
                                                  function (vesselName) {
                                                    return _c("el-option", {
                                                      key: vesselName.value,
                                                      attrs: {
                                                        label: vesselName.label,
                                                        value: vesselName.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("船次/航次"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "voyageNo" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  size: "small",
                                                  placeholder:
                                                    "请输入船次/航次",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onInput(
                                                      "voyageNo"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.voyageNo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "voyageNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.voyageNo",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("航线"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "routeLine" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  size: "small",
                                                  placeholder: "请输入",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onInput(
                                                      "routeLine"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.routeLine,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "routeLine",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.routeLine",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("封条号"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "sealNumber" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  size: "small",
                                                  placeholder: "请输入封条号",
                                                },
                                                model: {
                                                  value: item.sealNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "sealNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.sealNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("提单件数(件)"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "qty" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  size: "small",
                                                  placeholder: "请输入提单件数",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onInput("qty")
                                                  },
                                                },
                                                model: {
                                                  value: item.qty,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "qty", $$v)
                                                  },
                                                  expression: "item.qty",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("方数(CBM)"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "weightCbm" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  size: "small",
                                                  placeholder: "请输入方数",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onInput(
                                                      "weightCbm"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.weightCbm,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "weightCbm",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.weightCbm",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "field" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("重量(KG)"),
                                          ]),
                                          _c(
                                            "el-form-item",
                                            { attrs: { prop: "weightKgs" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "220px" },
                                                attrs: {
                                                  size: "small",
                                                  placeholder: "请输入重量",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onInput(
                                                      "weightKgs"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.weightKgs,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "weightKgs",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.weightKgs",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  })
                : _vm._e(),
              _c("div", { staticClass: "panel-btn-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "panel-btn",
                    on: {
                      click: function ($event) {
                        return _vm.ok("billInfo")
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: { src: require("@/assets/images/bill/track.png") },
                    }),
                    _vm._v(" 确定修改 "),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }